/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const CloseSm: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="close-sm" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M476 396.6666666666668L396.6666666666667 476.0000000000001L600.6666666666666 680L396.6666666666667 882.5833333333333L476 961.9166666666669L680 757.9166666666667L882.5833333333333 961.9166666666669L961.9166666666666 882.5833333333333L757.9166666666665 680L961.9166666666666 476.0000000000001L882.5833333333331 396.6666666666668L680 600.6666666666666L476 396.6666666666668z" : "M380.8 317.3333333333333L317.3333333333334 380.8L480.5333333333334 544L317.3333333333334 706.0666666666666L380.8 769.5333333333333L544 606.3333333333333L706.0666666666667 769.5333333333333L769.5333333333333 706.0666666666666L606.3333333333333 544L769.5333333333333 380.8L706.0666666666666 317.3333333333333L544 480.5333333333333L380.8 317.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
CloseSm.displayName = `Blueprint5.Icon.CloseSm`;
export default CloseSm;
